import _ from 'lodash'
import { golfEnums } from '../enums/golfEnums'
import { getGolfMatchInfo } from '../cnr/reducers/reducerHelpers/golfMatchHelpers'
// import { createMatchScorecards } from './createMatchScorecards'

export const _matchPlayPercs = {
  alterateShot: {
    low: .60,
    high: .40
  },
  bestBall: .90,
  singles: 1.00
}

export const calcGolferHoleWinners = (golfMatch, golfer) => {
  const { holeWinners } = golfMatch ?? {}
  const { teamNumber } = golfer ?? {}
  const oppNumber = teamNumber === 1 ? 2 : 1
  const w = _.filter(holeWinners, { winningTeam: teamNumber })
  const l = _.filter(holeWinners, { winningTeam: oppNumber })
  const t = _.filter(holeWinners, { winningTeam: 0 })
  return { wins: w.length, ties: t.length, losses: l.length }
}

export const calcGolferPartnersAndOpponents = (golfMatch, golfer, golfers, matchStatus) => {

  const { team1, team2, round } = golfMatch ?? {}
  const { teamNumber, _itemKey: _itemKey_g } = golfer ?? {}
  const { finished, winner, finalScore } = matchStatus ?? {}
  const won = finished && winner === teamNumber ? true : false

  const _matchStatus = { finished, winner, finalScore, tied: winner ? false : true, round, won }

  let pp;
  let opp;

  const pps = {};
  const opps = {};

  switch (teamNumber) {
    case 1:
      pp = team1
      opp = team2
      break;
    default:
      pp = team2
      opp = team1
      break;
  }

  _.forEach(pp, (t, tk) => {
    const golfer = golfers[tk]
    const { _itemKey, firstName, lastName, tournamentHandicapIndex } = golfer ?? {}
    if (_itemKey_g !== tk) {
      pps[tk] = {
        _itemKey,
        firstName,
        lastName,
        tournamentHandicapIndex,
        rounds: [round],
        matchStatuses: [_matchStatus],
        finalScore,
      }
    }
  })

  _.forEach(opp, (t, tk) => {
    const golfer = golfers[tk]
    const { _itemKey, firstName, lastName, tournamentHandicapIndex } = golfer ?? {}
    opps[tk] = {
      _itemKey,
      firstName,
      lastName,
      tournamentHandicapIndex,
      rounds: [round],
      matchStatuses: [_matchStatus],
      finalScore
    }
  })

  return { opps, pps }
}

export const calcMatchStatus = (golfMatch, holes, teams = {}, holeNumber, forUpdate) => {

  const { holeWinners, holeScores, matchNumber, id } = golfMatch;

  // Only include holes < holeNumber if holeNumber provided
  const filteredWinners = holeNumber
    ? _.pickBy(holeWinners, (i) => i.order < holeNumber)
    : holeWinners;

  const gmi = getGolfMatchInfo(golfMatch, holes);
  const { allGolfersStroking } = gmi;

  const { team1, team2 } = teams ? teams : {}
  const team1Name = team1?.name ?? "";
  const team2Name = team2?.name ?? "";

  const holesScored = filteredWinners ? getLastHolePlayed(filteredWinners) : 0;
  const holesRemaining = 18 - holesScored;
  const matchHcps = getMatchLowHcp(golfMatch);

  // --- Base status object
  const matchStatus = {
    _itemKey: id,
    _lastHolePlayed: `thru ${holesScored}`,
    dormie: false,
    finalScore: holesScored === 0 ? "N/S" : "Tied",
    finished: false,
    golferScores: null,
    holeScores: null,
    holesRemaining,
    holesScored,
    lastHolePlayed: holesScored,
    lastHoleResult: null,
    leadingBy: 0,
    leadingTeam: 0,
    matchHcps,
    matchNumber,
    matchScore: "--",
    nextHole: holesScored + 1,
    notStarted: holesScored === 0,
    status: "--",
    team1: { holesWon: 0, holesHalved: 0, leadingBy: 0, leading: true, won: false, status: "--" },
    team2: { holesWon: 0, holesHalved: 0, leadingBy: 0, leading: true, won: false, status: "--" },
    tied: false,
    winner: null,
  };

  // --- Golfer scores
  const golferScores = {};
  if (holes && holeScores && !holeNumber) {
    const addGolfer = (g, key) => {
      golferScores[key] = { total: 0, toPar: 0, totalNet: 0, toParNet: 0, hcp: g.handicap };
    };

    _.forEach(team1, addGolfer);
    _.forEach(team2, addGolfer);

    _.forEach(holes, (h) => {
      const { par, holeNumber, handicap } = h;
      if (!holeScores[holeNumber]) return;

      _.forEach(golferScores, (gs, gsKey) => {
        const score = holeScores[holeNumber]?.[gsKey];
        if (!score) return;

        let netScore = score;
        if (gs.hcp <= handicap) netScore--;

        gs.total += score;
        gs.toPar += score - par;
        gs.totalNet += netScore;
        gs.toParNet += netScore - par;
      });
    });
  }

  // --- Hole winners / status
  if (filteredWinners) {
    const hs1 = _.filter(filteredWinners, { winningTeam: 1 });
    const hs2 = _.filter(filteredWinners, { winningTeam: 2 });

    matchStatus.team1.holesWon = hs1.length;
    matchStatus.team2.holesWon = hs2.length;
    matchStatus.team1.holeWinners = Object.keys(_.pickBy(filteredWinners, { winningTeam: 1 }));
    matchStatus.team2.holeWinners = Object.keys(_.pickBy(filteredWinners, { winningTeam: 2 }));

    // --- Lead calculation
    const { holesWon: t1Won } = matchStatus.team1;
    const { holesWon: t2Won } = matchStatus.team2;

    if (t1Won > t2Won) {
      matchStatus.leadingTeam = 1;
      matchStatus.leadingBy = t1Won - t2Won;
      matchStatus.team1 = { ...matchStatus.team1, leadingBy: matchStatus.leadingBy, status: `${matchStatus.leadingBy} Up`, leading: true, name: team1Name };
      matchStatus.statusLine = `Match #${matchNumber} (${gmi.matchLine}):\n${team1Name} now leads ${matchStatus.team1.status} thru ${holesScored}.`;
    } else if (t2Won > t1Won) {
      matchStatus.leadingTeam = 2;
      matchStatus.leadingBy = t2Won - t1Won;
      matchStatus.team2 = { ...matchStatus.team2, leadingBy: matchStatus.leadingBy, status: `${matchStatus.leadingBy} Up`, leading: true, name: team2Name };
      matchStatus.statusLine = `Match #${matchNumber} (${gmi.matchLine}):\n${team2Name} now leads ${matchStatus.team2.status} thru ${holesScored}.`;
    } else {
      matchStatus.status = matchStatus.team1.status = matchStatus.team2.status = "Tied";
      matchStatus.statusLine = `Match #${matchNumber} (${gmi.matchLine}):\nMatch is Tied.`;
    }

    // --- Last hole result
    const lastHole = matchStatus.lastHolePlayed;
    if (lastHole > 0 && filteredWinners[lastHole]) {
      const { winningTeam } = filteredWinners[lastHole];
      const lastResult = { matchNumber, hole: lastHole, team: null, result: null, status: null };
      if (winningTeam === 0) lastResult.result = `Halved`;
      if (winningTeam === 1) { lastResult.team = team1; lastResult.result = `${team1Name} won`; }
      if (winningTeam === 2) { lastResult.team = team2; lastResult.result = `${team2Name} won`; }
      matchStatus.lastHoleResult = lastResult;
    }

    if (!holeNumber) {
      matchStatus.holeStrokesStatus = getHolesWon(holes, filteredWinners, allGolfersStroking);
    }
  }
  // --- Final score & conditions
  const { leadingBy, leadingTeam } = matchStatus;

  if (leadingBy > holesRemaining) {
    matchStatus.finished = true;
    matchStatus.winner = leadingTeam;
    matchStatus.finalScore = holesRemaining <= 0 ? `${leadingBy} Up` : `${leadingBy} & ${holesRemaining}`;
  } else if (leadingBy === holesRemaining) {
    if (holesRemaining === 0) {
      matchStatus.finished = true;
      matchStatus.finalScore = "Tied";
    } else {
      matchStatus.dormie = true;
      matchStatus.dormieTeam = leadingTeam;
      matchStatus.finalScore = `${leadingBy} Up`;
    }
  } else {
    matchStatus.finalScore = leadingBy ? `${leadingBy} Up` : "Tied";
    if (leadingBy === holesRemaining - 1) matchStatus.potentialClosingHole = true;
  }

  // --- Derived fields
  matchStatus.golferScores = golferScores;
  matchStatus.holeScores = holeScores;
  matchStatus.holeWinners = filteredWinners;
  matchStatus.matchScore = matchStatus.notStarted ? `M ${matchNumber}` : matchStatus.finished ? matchStatus.finalScore : matchStatus.finalScore;

  return matchStatus;
};

const getMatchLowHcp = (golfMatch) => {

  const team1Hcps = getTeamHcp(golfMatch.team1)
  const team2Hcps = getTeamHcp(golfMatch.team2)

  if (team1Hcps.sum < team2Hcps.sum) {
    team2Hcps.actual = Math.ceil((team2Hcps.sum - team1Hcps.sum) * .40)
  } else if (team2Hcps.sum < team1Hcps.sum) {
    team1Hcps.actual = Math.ceil((team1Hcps.sum - team2Hcps.sum) * .40)
  } else {
    team1Hcps.actual = 0
    team2Hcps.actual = 0
  }

  if (team1Hcps.altShot < team2Hcps.altShot) {
    team2Hcps.actual_alt = Math.ceil((team2Hcps.altShot - team1Hcps.altShot))
  } else if (team2Hcps.altShot < team1Hcps.altShot) {
    team1Hcps.actual_alt = Math.ceil((team1Hcps.altShot - team2Hcps.altShot))
  } else {
    team1Hcps.actual_alt = 0
    team2Hcps.actual_alt = 0
  }

  const hcpLowG = getLowCourseHandicaps(golfMatch)
  // hcpLowG = getLowCourseHandicap(golfMatch.team1, hcpLowG)
  // hcpLowG = getLowCourseHandicap(golfMatch.team2, hcpLowG)

  return ({ team1Handicaps: team1Hcps, team2Handicaps: team2Hcps, lowHandicapG: hcpLowG })

}

const getLowCourseHandicaps = (golfMatch) => {

  let hcpLowG = {
    lowHandicap: 100,
    lowGolfer: null
  }

  const { team1, team2 } = golfMatch
  hcpLowG = getLowCourseHandicap(team1, hcpLowG)
  hcpLowG = getLowCourseHandicap(team2, hcpLowG)

  return hcpLowG
}

function findLowestHandicapAndTeam(golfMatch) {

  const { team1, team2 } = golfMatch

  const lowestHandicapGolfer = _.minBy([...Object.values(team1), ...Object.values(team2)], 'courseHandicap');

  return lowestHandicapGolfer
  // Return the lowest handicap and the team with the lowest handicap
  // return {
  //   lowestHandicapGolfer: lowestHandicapGolfer,
  //   teamWithLowestHandicap: lowestHandicapGolfer === team1 ? 'Team 1' : 'Team 2',
  // };
}

const getLowCourseHandicap = (tg, hcpLowG) => {
  if (tg) {
    Object.keys(tg).forEach(key => {
      const g = tg[key]
      const { courseHandicap, matchHandicap } = g
      const h = matchHandicap
      if (parseInt(h) < hcpLowG.lowHandicap) {
        hcpLowG.lowHandicap = parseInt(h)
        hcpLowG.lowGolfer = g
      }
    })
  }

  return hcpLowG
}

const getTeamHcp = (golfers_team, roundType) => {

  let hcpSum = 0

  if (golfers_team) {
    Object.keys(golfers_team).forEach(key => {
      const g = golfers_team[key]
      const { matchHandicap } = g ? g : {}
      hcpSum += Math.round(matchHandicap);
    })
  }

  const teamHcp = {
    sum: hcpSum,
    ave: Math.ceil(hcpSum / 2),
    actual: 0,
  }

  switch (roundType) {
    case golfEnums.roundTypes.alternateShot:
    case golfEnums.roundTypes.alternateShot1:
    case golfEnums.roundTypes.alternateShot2:
      teamHcp.altShot = golfers_team && getTeamAltShotHandicap(golfers_team)
      break;

    default:
    // nothing
  }

  return teamHcp
}

const getTeamAltShotHandicap = (golfers) => {

  const _golfers = Object.values(golfers)

  const courseHandicaps = _golfers.map(golfer => golfer.courseHandicap);
  const lowerHandicap = Math.min(...courseHandicaps);
  const higherHandicap = Math.max(...courseHandicaps);

  if (lowerHandicap !== higherHandicap) {
    const golfer_low = _.find(golfers, { courseHandicap: lowerHandicap })
    const golfer_high = _.find(golfers, { courseHandicap: higherHandicap })
    if (golfer_low) {
      golfer_low.matchHandicap_alt = Math.round(_matchPlayPercs.alterateShot.low * lowerHandicap)
      golfer_low.matchHandicap_alt_perc = _matchPlayPercs.alterateShot.low
    }
    if (golfer_high) {
      golfer_high.matchHandicap_alt = Math.round(_matchPlayPercs.alterateShot.high * higherHandicap)
      golfer_high.matchHandicap_alt_perc = _matchPlayPercs.alterateShot.high
    }
    const teamCourseHandicap = golfer_low && golfer_high ? golfer_low.matchHandicap_alt + golfer_high.matchHandicap_alt : 0;
    return Math.round(teamCourseHandicap);
  } else {
    const teamCourseHandicap = ((lowerHandicap + higherHandicap) / 2);
    return Math.round(teamCourseHandicap);
  }
}

export const getMatchHandicaps = (golfers, roundType) => {

  let hcpLowG = getLowCourseHandicaps(golfers)

  // const x = findLowestHandicapAndTeam(golfers)

  switch (roundType) {

    case golfEnums.roundTypes.alternateShot:
    case golfEnums.roundTypes.alternateShot1:
    case golfEnums.roundTypes.alternateShot2:

      const team1Hcps = getTeamHcp(golfers.team1, roundType)
      const team2Hcps = getTeamHcp(golfers.team2, roundType)

      if (team1Hcps.altShot < team2Hcps.altShot) {
        team2Hcps.actual_alt = Math.ceil((team2Hcps.altShot - team1Hcps.altShot))
        team1Hcps.actual_alt = 0
        team1Hcps.lowT = true
      } else if (team2Hcps.altShot < team1Hcps.altShot) {
        team1Hcps.actual_alt = Math.ceil((team1Hcps.altShot - team2Hcps.altShot))
        team2Hcps.actual_alt = 0
        team2Hcps.lowT = true
      } else {
        team1Hcps.actual_alt = 0
        team2Hcps.actual_alt = 0
      }

      return { team1Handicaps: team1Hcps, team2Handicaps: team2Hcps, lowHandicapG: hcpLowG }

    default:
      return { lowHandicapG: hcpLowG, team1Handicaps: {}, team2Handicaps: {} }
  }

}

export const getLastHolePlayed = (holeWinners) => {
  const s = holeWinners ? Object.keys(holeWinners).pop() : 0
  return parseInt(s)
}

const getHolesWon = (holes, holeWinners, allGolfersStroking) => {

  const teamStrokes = {
    team1: {
      strokingAdvantage1: [],
      strokingAdvantage2: [],
      strokingDisadvantage1: [],
      strokingDisadvantage2: [],
      strokesNone: [],
      strokesEven: [],
      strokesDiff: [],
    },
    team2: {
      strokingAdvantage1: [],
      strokingAdvantage2: [],
      strokingDisadvantage1: [],
      strokingDisadvantage2: [],
      strokesNone: [],
      strokesEven: [],
      strokesDiff: [],
    }
  }

  const teamHoleStrokes = {
    strokingAdvantage1: {
      team1: [],
      team2: []
    },
    strokingAdvantage2: {
      team1: [],
      team2: []
    },
    strokingDisadvantage1: {
      team1: [],
      team2: []
    },
    strokingDisadvantage2: {
      team1: [],
      team2: []
    },
    strokesNone: {
      team1: [],
      team2: []
    },
    strokesEven: {
      team1: [],
      team2: []
    },
    strokesDiff: {
      team1: [],
      team2: []
    },
  }

  const holeStrokes = {}

  if (holes) {
    Object.keys(holes).forEach(holeNumber => {
      const holeWinnner = holeWinners ? holeWinners[holeNumber] : {}
      const { winningTeam } = holeWinnner ? holeWinnner : {}
      const losingTeam = winningTeam === 1 ? 2 : 1
      const golfersStroking = allGolfersStroking ? allGolfersStroking[holeNumber] : []
      // if there is a winning team AND some golfers are gettings strokes

      if (!holeStrokes[holeNumber]) {
        holeStrokes[holeNumber] = {
          strokingAdvantage1: 0,
          strokingAdvantage2: 0,
          strokingDisadvantage1: 0,
          strokingDisadvantage2: 0,
          oppStrokingOnly: 0,
          strokesNone: 0,
          strokesEven: 0,
          strokesDiff: 0,
        }
      }

      if (winningTeam > 0) {

        const strokes_winner = _.filter(golfersStroking, { teamNumber: winningTeam })
        const strokes_loser = _.filter(golfersStroking, { teamNumber: losingTeam })

        // WINNER strokes, LOSER none
        if (strokes_winner.length > 0 && strokes_loser.length === 0) {
          if (strokes_winner.length === 2) {
            teamHoleStrokes.strokingAdvantage2['team' + winningTeam].push(parseInt(holeNumber))
            teamStrokes['team' + winningTeam].strokingAdvantage2.push(parseInt(holeNumber))
            holeStrokes[holeNumber].strokingAdvantage2++
          } else {
            teamHoleStrokes.strokingAdvantage1['team' + winningTeam].push(parseInt(holeNumber))
            teamStrokes['team' + winningTeam].strokingAdvantage1.push(parseInt(holeNumber))
            holeStrokes[holeNumber].strokingAdvantage1++
          }
        }

        if (strokes_winner.length === 2 && strokes_loser.length === 1) {
          teamHoleStrokes.strokingAdvantage1['team' + winningTeam].push(parseInt(holeNumber))
          teamStrokes['team' + winningTeam].strokingAdvantage1.push(parseInt(holeNumber))
          holeStrokes[holeNumber].strokingAdvantage1++
        }

        if (strokes_loser.length > 0 && strokes_winner.length === 0) {
          if (strokes_loser.length === 2) {
            teamHoleStrokes.strokingDisadvantage2['team' + winningTeam].push(parseInt(holeNumber))
            teamStrokes['team' + winningTeam].strokingDisadvantage2.push(parseInt(holeNumber))
            holeStrokes[holeNumber].strokingDisadvantage2++
          } else {
            teamHoleStrokes.strokingDisadvantage1['team' + winningTeam].push(parseInt(holeNumber))
            teamStrokes['team' + winningTeam].strokingDisadvantage1.push(parseInt(holeNumber))
            holeStrokes[holeNumber].strokingDisadvantage1++
          }
        }

        if (strokes_loser.length === 2 && strokes_winner.length === 1) {
          teamHoleStrokes.strokingDisadvantage1['team' + winningTeam].push(parseInt(holeNumber))
          teamStrokes['team' + winningTeam].strokingDisadvantage1.push(parseInt(holeNumber))
          holeStrokes[holeNumber].strokingDisadvantage1++
        }

        // neither team has strokes
        if (strokes_winner.length === 0 && strokes_loser.length === 0) {
          teamHoleStrokes.strokesNone['team' + winningTeam].push(parseInt(holeNumber))
          teamStrokes['team' + winningTeam].strokesNone.push(parseInt(holeNumber))
          holeStrokes[holeNumber].strokesNone++
        }

        if (strokes_winner.length > 0 && strokes_loser.length > 0 && (strokes_winner.length === strokes_loser.length)) {
          teamHoleStrokes.strokesEven['team' + winningTeam].push(parseInt(holeNumber))
          teamStrokes['team' + winningTeam].strokesEven.push(parseInt(holeNumber))
          holeStrokes[holeNumber].strokesEven++
        }
      }
    })
  }

  return { teamStrokes, teamHoleStrokes, holeStrokes }

}

const getMatchPlayOdds = (team1Wins, team2Wins, ties, holesRemaining) => {

  const p1 = 1 / 3; // Team1 wins hole
  const p2 = 1 / 3; // Team2 wins hole
  const pt = 1 / 3; // Tie hole

  const lead = team1Wins - team2Wins;

  // dp[h] is a map: { d: [pWin1, pWin2, pTie] } for h holes remaining and lead d
  let dp = [];

  // Base case: 0 holes remaining
  let base = {};
  base[0] = [0, 0, 1]; // tie
  base[1] = [1, 0, 0]; // Team1 win
  base[-1] = [0, 1, 0]; // Team2 win
  dp[0] = base;

  // Build up for 1..holesRemaining
  _.forEach(_.range(1, holesRemaining + 1), (h) => {
    let current = {};
    _.forEach(_.range(-h, h + 1), (d) => {
      const prev = dp[h - 1];

      // Transition: check possible moves
      const win1 = prev[d + 1] || [0, 0, 0];
      const tie = prev[d] || [0, 0, 0];
      const win2 = prev[d - 1] || [0, 0, 0];

      current[d] = [
        p1 * win1[0] + pt * tie[0] + p2 * win2[0],
        p1 * win1[1] + pt * tie[1] + p2 * win2[1],
        p1 * win1[2] + pt * tie[2] + p2 * win2[2],
      ];
    });
    dp[h] = current;
  });

  const result = dp[holesRemaining][lead] || [0, 0, 0];
  const [pWin1, pWin2, pTie] = result;

  return {
    team1WinPct: Math.round(pWin1 * 100),
    team2WinPct: Math.round(pWin2 * 100),
    tiePct: Math.round(pTie * 100),
  };
}
